import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Track if a redirect is already in progress to avoid loops
let redirecting = false;

api.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status;
    // Only redirect on 401 from auth-related endpoints
    const url = err.config?.url || '';
    const isAuthError = status === 401 && !url.includes('/ai/history');
    if (isAuthError && !redirecting) {
      redirecting = true;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
